<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/lolita_hall.jpg" alt="Lolita Hall">
          </figure>
           <div class="finger-print"><img class="finger-print" src="@/assets/images/fingerprints/fingerprint-three.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Lolita Hall</h2>
      <p class="job-title">Student</p>

        <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

        <p>In the last four years, I moved back to my hometown of Manchester to pursue a career in teaching. I have previously worked as a teaching assistant, with most of my experience being within the early years sector. I am a parent to my 7 year old son, as well as a parent governor. Since starting the course, I took on the opportunity to lead the Black and Asian student network for the faculty of health and education, and have since built a network of great relationships with students and staff.</p>

        <p class="profile-statement-interviewer">Why Man Met University?</p>

        <p>I moved back to Manchester to pursue my career, so Man Met was always a choice. After some research, I decided to choose Man Met because of the school direct course it offered. I liked that there was a partnership with the Manchester Schools Alliance, and that most of my experience would be classroom based, which was what I was used to and comfortable with. I also knew the area well and love the location of the Brooks building.</p>


        <p class="profile-statement-interviewer">What is something that you love about your culture or heritage?</p> 

        <p>I love that I have a mixed Polish and Jamaican heritage. I love the contrast of the two cultures and the different experiences I have when visiting them both. I love the music and dance culture of Jamaica and love the many traditions of the Polish culture.</p>


        <p class="profile-statement-interviewer">What does it look like to bring your whole self to your education? </p>

        <p>For me it is everything. I want children to feel comfortable through expressing themselves and feeling empowered. I think this is achieved when modelled. Being a non-white teacher and representing ‘people of colour’ is important. Bringing my whole self means talking about my experiences and being listened to, in addition to using my voice, and having respectful and meaningful conversations with people from all backgrounds and walks of life.</p>


        <p class="profile-statement-interviewer">What are you most proud of?</p>

        <p>I am most proud of finding my voice and continuing to grow in confidence to use it. I am proud of raising my son alongside my other commitments and my resilience in developing myself, personally and professionally.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;

    & figure {
      text-align: left;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>